import React, { Component } from 'react'

import TextWithFieldname from '../texts/TextWithFieldname';
import Dico from '../../helpers/Dico';
import ContMessageI18N from '../../containers/ContMessageI18N';

class TableAmountCategory extends Component {

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }

	isNumber(value) {
		return !isNaN(value) && !(value === true || value === false);
	}
	buildNbCols(isThirdColumn){
		var nbCols = 3;
		if (isThirdColumn) {
			nbCols++;
		}
		if (this.props.collections != null && Object.keys(this.props.collections).length > 0) {
			nbCols++;
		}
		return nbCols;
	}
	buildMainVariables(){
		var isThirdColumn = false;
		var isPct = false;
		var isAmountInclExclTax = false;
		for (var kv in Object.values(this.props.amounts)) {
			var v = Object.values(this.props.amounts)[kv];
			if (v != null && ((!v.amountInclTax && !v.amountExclTax) || v.pct != null)) {
				isThirdColumn = true;
				if (v.pct != null) {
					isPct = true;
				}
			}
			if (v && (v.amountInclTax || v.amountExclTax)) {
				isAmountInclExclTax = true;
			}
		}
		return {isThirdColumn, isPct, isAmountInclExclTax};
	}

	render() {
		const mainVariables = this.buildMainVariables();
		var isThirdColumn = mainVariables.isThirdColumn;
		var isPct = mainVariables.isPct;
		var isAmountInclExclTax = mainVariables.isAmountInclExclTax;
		var nbCols = this.buildNbCols(isThirdColumn);
		return (
			<TextWithFieldname fieldname={this.props.fieldname} developperView={this.props.developperView} complexChild={true}>
				<div className="row shadow rounded p-0 m-1 table-responsive">
					<table className="table table-light table-striped">
						{this.renderHeader(isAmountInclExclTax, isThirdColumn, isPct)}
						<tbody>
							{Object.keys(this.props.amounts).map((amtKey, index) => {
								var isCollection = this.props.collections != null && this.props.collections[amtKey] != null;
								if (!isCollection) {
									return (<React.Fragment key={index}>{this.renderSingleObject(amtKey, isAmountInclExclTax)}</React.Fragment>);
								} else {
									return (<React.Fragment key={index}>{this.renderCollection(amtKey, isAmountInclExclTax, nbCols)}</React.Fragment>);
								}
							})}
						</tbody>
					</table>
				</div>
			</TextWithFieldname>
		)
	}

	renderHeader(isAmountInclExclTax, isThirdColumn, isPct) {
		var headExclTax = this.props.developperView ? 'amountExclTax' : this.getMessage('generics.amountExclTax');
		var headInclTax = this.props.developperView ? 'amountInclTax' : this.getMessage('generics.amountInclTax');
		var headOtherDev = isPct ? 'pct' : '';
		var headOther = this.props.developperView ? headOtherDev : this.getMessage('generics.valcoef');
		var title = this.props.developperView ? this.props.fieldname : this.props.title;
		return (
			<thead>
				<tr className='table-primary'>
					<th className='text-center'>{title}</th>
					{isAmountInclExclTax && <th className='text-end'>{headExclTax}</th>}
					{isAmountInclExclTax && <th className='text-end'>{headInclTax}</th>}
					{isThirdColumn && <th className='text-end'>{headOther}</th>}
				</tr>
			</thead>
		);
	}

	buildRowHeadSingleObject(amtKey){
		return this.props.developperView ? amtKey
		: this.getMessage(`${this.props.i18nPrefix}.${amtKey}`);
	}
	renderSingleObject(amtKey, isAmountInclExclTax) {
		var rowHead = this.buildRowHeadSingleObject(amtKey);
		return (
			<tr>
				<td className='text-center' >{rowHead}</td>
				{isAmountInclExclTax && this.props.amounts[amtKey] != null
					&& <td className='text-end'>
						{this.props.developperView && this.props.amounts[amtKey].amountExclTax}
						{!this.props.developperView && Dico.getAmountFormatted(this.props.amounts[amtKey], 'HT', this.props.context.countryCode, this.props.context.languageCode)}
					</td>
				}
				{isAmountInclExclTax && this.props.amounts[amtKey] != null
					&& <td className='text-end'>
						{this.props.developperView && this.props.amounts[amtKey].amountInclTax}
						{!this.props.developperView && Dico.getAmountFormatted(this.props.amounts[amtKey], 'TC', this.props.context.countryCode, this.props.context.languageCode)}
					</td>
				}
				{this.props.amounts[amtKey] != null && this.props.amounts[amtKey].pct != null
					&& <td className='text-end'>
						{this.props.developperView && this.props.amounts[amtKey].pct}
						{!this.props.developperView && Dico.getDoubleFormatted(this.props.amounts[amtKey].pct, this.props.context.countryCode, this.props.context.languageCode, 'percent')}
					</td>
				}
				{this.props.amounts[amtKey] != null && this.props.amounts[amtKey].amountInclTax == null && this.props.amounts[amtKey].amountExclTax == null
					&& <td className='text-end'>
						{this.props.developperView && this.props.amounts[amtKey]}
						{!this.props.developperView && this.isNumber(this.props.amounts[amtKey])
							&& Dico.getDoubleFormatted(this.props.amounts[amtKey], this.props.context.countryCode,
								this.props.context.languageCode, amtKey === 'depositPct' ? 'percent' : 'currency')}
						{!this.props.developperView && !this.isNumber(this.props.amounts[amtKey])
							? this.getMessage(`${this.props.i18nPrefix}.${amtKey}.${this.props.amounts[amtKey]}`) : ''}
					</td>
				}
			</tr>
		);
	}

	renderCollection(amtKey, isAmountInclExclTax, nbCols) {
		return (
			<React.Fragment>
				<tr>
					<th className='text-center' colSpan={nbCols}>
						{this.props.developperView && amtKey}
						{!this.props.developperView && this.getMessage(`${this.props.i18nPrefix}.${amtKey}`)}
					</th>
				</tr>
				{(this.props.amounts[amtKey] || []).map((occ, index2) => (
					<tr key={index2}>
						<td className='text-center' >{occ[this.props.collections[amtKey]]}</td>
						{isAmountInclExclTax && <td className='text-end'>
							{this.props.developperView && occ.amountExclTax}
							{!this.props.developperView && Dico.getAmountFormatted(occ, 'HT', this.props.context.countryCode, this.props.context.languageCode)}
						</td>}
						{isAmountInclExclTax && <td className='text-end'>
							{this.props.developperView && occ.amountInclTax}
							{!this.props.developperView && Dico.getAmountFormatted(occ, 'TC', this.props.context.countryCode, this.props.context.languageCode)}
						</td>}
						{occ.pct != null && <td className='text-end'>
							{this.props.developperView && occ.pct}
							{!this.props.developperView && Dico.getDoubleFormatted(occ.pct, this.props.context.countryCode, this.props.context.languageCode, 'percent')}
						</td>}
						{occ.campaign != null && <td className='text-start'>
							{`campaign=${occ.campaign}`}
						</td>}
						{occ.contributor != null && <td className='text-start'>
							{`contributor=${occ.contributor}`}
						</td>}
						{occ.externalId != null && <td className='text-start'>
							{`externalId=${occ.externalId}`}
						</td>}
						{occ.type != null && <td className='text-start'>
							{`type=${occ.type}`}
						</td>}
						{occ.pctBasis != null && <td className='text-start'>
							{`pctBasis=${occ.pctBasis}`}
						</td>}
					</tr>
				))}
			</React.Fragment>
		);
	}
}

export default (TableAmountCategory)
